// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6027":"eb31fb5f98d056b6","8444":"b0f679f8ce408c75"}[chunkId] + ".js";
};